import React from 'react'
import WeAreBuildingBanking from './WeAreBuildingBanking';
import FooterSection from '../index/FooterSection';
import OurPromises from './OurPromises';
import OurTeam from './OurTeam';
import FAQ from './FAQ';

export default function About() {
  return (
    <div>
      <WeAreBuildingBanking />
      <OurPromises />
      <OurTeam />
      <FAQ />
      <FooterSection />
    </div>
  )
}
